package uz.mint.frontend.pages.en

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.LegalPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.PrivacyPolicy
import uz.mint.frontend.i18n.stringsFor
import uz.mint.frontend.seo.IndexablePage

private val LOCALE = Locale.EN

@InitRoute
fun initEnglishPrivacyPage(ctx: InitRouteContext) {
    val strings = stringsFor(LOCALE)
    ctx.data.add(
        PageLayoutData(
            strings.legalPrivacy + " — Mint.uz",
            LOCALE,
            strings.legalPrivacy,
            page = IndexablePage.PRIVACY,
        )
    )
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun EnglishPrivacyPage() {
    LegalPage(LOCALE, stringsFor(LOCALE).legalPrivacy, PrivacyPolicy) { it.privacyPath }
}
